// WebSocket service for counsellor portal real-time messaging
// Connects to backend WebSocket server

const WS_BASE = import.meta.env.VITE_API_WS_URL;

class CounsellorMessagingWebSocket {
  constructor() {
    this.ws = null;
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
    this.reconnectDelay = 3000;
    this.messageHandlers = [];
    this.connectionHandlers = [];
    this.userId = null;
    this.userType = 'doctor';
  }

  connect(userId) {
    this.userId = userId;

    // Don't reconnect if already connected for same user
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      return;
    }

    try {
      // Close existing connection if any
      if (this.ws) {
        this.ws.close();
      }

      // Create WebSocket connection
      this.ws = new WebSocket(`${WS_BASE}?user_id=${userId}&user_type=${this.userType}`);

      // this.ws.onopen = () => {
      //   // console.log('Counsellor WebSocket connected');
      //   this.reconnectAttempts = 0;
      //   this.notifyConnectionHandlers('connected');
      // };

      this.ws.onopen = () => {
        console.log("WebSocket connected");
        this.reconnectAttempts = 0;
        this.notifyConnectionHandlers('connected');
      };

      // this.ws.onmessage = (event) => {
      //   try {
      //     const data = JSON.parse(event.data);
      //     // console.log('Counsellor WebSocket message received:', data);

      //     // Notify all message handlers
      //     this.messageHandlers.forEach(handler => handler(data));
      //   } catch (error) {
      //     console.error('Error parsing WebSocket message:', error);
      //   }
      // };

      this.ws.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          console.log("WebSocket received:", data);
          this.messageHandlers.forEach(handler => handler(data));
        } catch (error) {
          console.error('Error parsing WebSocket message:', error);
        }
      };

      this.ws.onerror = (error) => {
        console.error('Counsellor WebSocket error:', error);
        this.notifyConnectionHandlers('error');
      };

      this.ws.onclose = () => {
        // console.log('Counsellor WebSocket disconnected');
        this.notifyConnectionHandlers('disconnected');
        this.attemptReconnect();
      };

    } catch (error) {
      // console.error('Error creating WebSocket connection:', error);
      this.notifyConnectionHandlers('error');
    }
  }

  attemptReconnect() {
    if (this.reconnectAttempts < this.maxReconnectAttempts && this.userId) {
      this.reconnectAttempts++;

      setTimeout(() => {
        this.connect(this.userId);
      }, this.reconnectDelay * this.reconnectAttempts);
    } else {
      // console.log('Max reconnect attempts reached or no conversation ID');
      this.notifyConnectionHandlers('failed');
    }
  }

  send(message) {
    if (this.ws && this.ws.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify(message));
    } else {
      // console.error('WebSocket is not connected');
    }
  }

  // onMessage(handler) {
  //   this.messageHandlers.push(handler);
  // }

  onMessage(handler) {
    if (!this.messageHandlers.includes(handler)) {
      this.messageHandlers.push(handler);
    }
  }

  removeMessageHandler(handler) {
    this.messageHandlers = this.messageHandlers.filter(h => h !== handler);
  }

  onConnectionChange(handler) {
    this.connectionHandlers.push(handler);
  }

  removeConnectionHandler(handler) {
    this.connectionHandlers = this.connectionHandlers.filter(h => h !== handler);
  }

  notifyConnectionHandlers(status) {
    this.connectionHandlers.forEach(handler => handler(status));
  }

  disconnect() {
    if (this.ws) {
      this.ws.onclose = null;
      this.ws.close();
      this.ws = null;
    }
    this.messageHandlers = [];
    this.connectionHandlers = [];
    this.userId = null;
  }

  isConnected() {
    return this.ws && this.ws.readyState === WebSocket.OPEN;
  }
}

// Export singleton instance
export const counsellorWebSocket = new CounsellorMessagingWebSocket();
